import axios from 'axios';
import { get } from 'http';
import React, { Suspense, useState,useEffect } from 'react';
import { createRoot } from 'react-dom/client';

const BlogPage =  () => {
    const [blogposts, setBlogposts] = useState("<h3>loading...</h3>");
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
   
    const getBlogPost = async (page:number) => {
        const blogposts = await axios.get('/blogposts?page='+page)
        setBlogposts(blogposts.data)
    }

    const getTotalPages = async () => {
        const totalPages = await axios.get('/blogposts/totalPages')
        setTotalPages(totalPages.data);
    }

    const nextPageHandler = async () => {
        if(page<totalPages-1){
            setPage(page+1)
            getBlogPost(page+1)
        }
    }

    const prevPageHandler = async () => {
        if(page>0){
            setPage(page-1)
            getBlogPost(page-1)
        }
    }

    useEffect(()=>{
              getBlogPost(0);
              getTotalPages();
           },[])
          
    return (
        <div style={{width: '100%', maxWidth: 900, margin: '0 auto', padding: '0 10px'}}>
        <Suspense fallback={<div>Loading...</div>}>
               <div className="blog_row" style={{wordBreak: 'break-word'}} dangerouslySetInnerHTML={{ __html: blogposts }} />
        </Suspense>
        <div style={{margin:"20px 0", display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: 10}} className='pagination'>
            <button className="prevButton" onClick={prevPageHandler} disabled={page===0} style={{flex: 1, marginRight: 5}}>Prev</button>
            <button className="nextButton" onClick={nextPageHandler} disabled={page===totalPages-1} style={{flex: 1, marginLeft: 5}}>Next</button>
        </div>
        </div>
       );
    }

function Blog() {
const domContainer = document.querySelector('#blog');
const root = createRoot(domContainer);
root.render(<BlogPage />);
}

Blog();

export default Blog;
